import {
  CANCEL_EDITING_REQUEST,
  CANCEL_REQUEST,
} from '../../shared/actions/shared.actions'
import { FSA } from '../../shared/types'
import { RESET_BREAKDOWN_LOCATION } from '../location/location.actions'
import {
  RESET_TOW_SERVICE_AVAILABILITY,
  TOW_SERVICE_AVAILABILITY,
} from './tow-service-availability.actions'
import { TowServiceAvailability } from './tow-service-availability.types'

export interface TowServiceAvailabilityState {
  towServiceAvailability?: TowServiceAvailability
  deferred: boolean
}

export const initialState: TowServiceAvailabilityState = {
  towServiceAvailability: null,
  deferred: false,
}

export function reducer(
  state: TowServiceAvailabilityState | undefined = initialState,
  action: FSA
): TowServiceAvailabilityState {
  switch (action.type) {
    // A new request drops any previous (e.g. dismissed) result. The in-flight
    // flag is not tracked here: loading.meta.ts already does it for every
    // REQUEST / SUCCESS / FAILURE (see selectIsTowServiceAvailabilityLoading).
    case TOW_SERVICE_AVAILABILITY.REQUEST: {
      return {
        towServiceAvailability: null,
        deferred: !!action.meta?.deferred,
      }
    }
    case TOW_SERVICE_AVAILABILITY.SUCCESS: {
      return {
        ...state,
        towServiceAvailability: action.payload.towServiceAvailability,
      }
    }
    // A failed request clears the result so a stale allow/block never outlives
    // its response. `deferred` is kept so the effect still holds the fail-open.
    case TOW_SERVICE_AVAILABILITY.FAILURE: {
      return {
        ...state,
        towServiceAvailability: null,
      }
    }
    // The result is scoped to one breakdown location / tow destination pair, so
    // a new breakdown location or a cancelled request invalidates it.
    case RESET_BREAKDOWN_LOCATION:
    case CANCEL_REQUEST:
    case CANCEL_EDITING_REQUEST:
    case RESET_TOW_SERVICE_AVAILABILITY: {
      return initialState
    }
    default:
      return state
  }
}
